import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { pdfjs } from 'react-pdf';

import LoadingWrapper from 'components/Common/LoadingWrapper';

const Document = React.lazy(() => import(/* webpackChunkName: "pdf" */ 'react-pdf').then(module => ({ default: module.Document })));
const Page = React.lazy(() => import(/* webpackChunkName: "pdf" */ 'react-pdf').then(module => ({ default: module.Page })));

function Repeat(props) {
  const { numTimes, children } = props;

  if (numTimes && children) {
    const items = [];
    for (let i = 1; i <= numTimes; i += 1) {
      items.push(children(i));
    }
    return <div>{items}</div>;
  }

  return <div />;
}

Repeat.propTypes = {
  numTimes: PropTypes.number,
  children: PropTypes.func.isRequired
};

Repeat.defaultProps = {
  numTimes: null
};

class ScrollPdfViewer extends Component {
  static propTypes = {
    file: PropTypes.string
  };

  static defaultProps = {
    file: null
  };

  constructor(props) {
    super(props);

    this.state = {
      numPages: null,
      isLoaded: false
    };

    pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.js';
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages, isLoaded: true });
  };

  /* eslint-disable-next-line class-methods-use-this */
  onDocumentLoadError = ({ error }) => {
    console.error(error.message);
  };

  render() {
    const { file } = this.props;
    const { numPages, isLoaded } = this.state;

    return (
      <div className="pdf-viewer">
        <React.Suspense fallback={ <LoadingWrapper loaded={ false } /> }>
          <Document
            file={ file }
            loading={ <LoadingWrapper loaded={ isLoaded } /> }
            noData={ <div className="viewer--nodata"><p>PDF cannot be shown here</p></div> }
            error={ <div className="viewer--error"><p>Sorry, there was a problem displaying the original form.<br />Please &apos;Close original form&apos; and try again.</p></div> }
            onLoadSuccess={ this.onDocumentLoadSuccess }
            onLoadError={ this.onDocumentLoadError }
            className="scroll-pdf-viewer"
            pageNumber={ 1 }
          >
            <Repeat numTimes={ numPages }>
              { index => (<Page
                key={ index }
                pageNumber={ index }
                width={ 1123 }
                noData={ <div /> }
                renderTextLayer={ false }
                renderAnnotationLayer={ false }
              />) }
            </Repeat>
          </Document>
        </React.Suspense>
      </div>
    );
  }
}

export default ScrollPdfViewer;
